import React from 'react';
import './Footer.css';
import { useTheme } from '@mui/material/styles'; // Import useTheme

const Footer = () => {
  const theme = useTheme(); // Initialize theme
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL
  const REACT_APP_BUILD_DATE = `${process.env.REACT_APP_BUILD_DATE || 'dev'}`;
  
  const [showMeta, setShowMeta] = React.useState(false); // State to toggle meta information

  const handleFooterClick = () => {
    setShowMeta((prev) => !prev); // Toggle the state
  };

  return (
    <footer 
      className="footer"
      style={{
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary // Or another color for good contrast
      }}
      onClick={handleFooterClick} // Add click handler
    >
      <div className="footer-content">
        <strong>La 🍌 Social Club - 2025</strong>
      </div>
      {showMeta && ( // Conditionally render meta information
        <div id="footer-meta-information" className="footer-meta">
          <span>Backend URL: {BACKEND_URL}</span>
          <span>Build Date: {REACT_APP_BUILD_DATE}</span>
        </div>
      )}
    </footer>
  );
};

export default Footer;
